import MToggle from './MToggle.vue';

MToggle.install = (app) => {
  app.component('MToggle', MToggle);
};

export { MToggle };
